import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, desc, light = false, center = false }) => (
  <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <span
        className={`text-sm font-semibold uppercase tracking-widest ${
          light ? "text-gold" : "text-brandred"
        }`}
        data-testid="section-eyebrow"
      >
        {eyebrow}
      </span>
    )}
    <h2
      className={`font-display text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.05] tracking-tight font-black mt-3 ${
        light ? "text-white" : "text-navy"
      }`}
    >
      {title}
    </h2>
    {desc && (
      <p className={`mt-4 text-base leading-relaxed ${light ? "text-white/70" : "text-muted-foreground"}`}>
        {desc}
      </p>
    )}
  </div>
);
